declare namespace $ {

	type $mol_text__text_shm_confirm_delete_1 = $mol_type_enforce<
		ReturnType< $shm_confirm_delete['question'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_confirm_delete_2 = $mol_type_enforce<
		ReturnType< $shm_confirm_delete['confirm_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_confirm_delete_3 = $mol_type_enforce<
		ReturnType< $shm_confirm_delete['confirm_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_confirm_delete_4 = $mol_type_enforce<
		ReturnType< $shm_confirm_delete['cancel_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_confirm_delete_5 = $mol_type_enforce<
		ReturnType< $shm_confirm_delete['cancel_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_confirm_delete_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_confirm_delete extends $mol_pick {
		Trigger_icon( ): $mol_icon_trash_can
		Question( ): $mol_text
		confirm_click( next?: any ): any
		Confirm( ): $mol_button_minor
		cancel_click( next?: any ): any
		Cancel( ): $mol_button_minor
		Content( ): $mol_view
		align( ): string
		title( ): string
		question( ): string
		confirm_title( ): string
		cancel_title( ): string
		confirmed( next?: any ): any
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=delete.view.tree.d.ts.map